import { render, staticRenderFns } from "./linkTenderMoney.vue?vue&type=template&id=a8161868&"
import script from "./linkTenderMoney.vue?vue&type=script&lang=js&"
export * from "./linkTenderMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports